import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="fluct-sticky-ad"
// Handles the PC sticky overlay ad provided by fluct BID STRAP.
// Shows the container only after a non-empty ad slot is rendered and
// wires up the close button to hide it on click.
export default class extends Controller {
  static targets = ["container", "closeButton"]
  static values = { slotId: String }

  connect() {
    this.dismissed = false
    this.boundHandler = this.handleSlotRenderEnded.bind(this)
    window.googletag = window.googletag || { cmd: [] }
    googletag.cmd.push(() => {
      googletag.pubads().addEventListener("slotRenderEnded", this.boundHandler)
    })
  }

  disconnect() {
    if (!this.boundHandler) return
    if (window.googletag && googletag.apiReady) {
      googletag.pubads().removeEventListener("slotRenderEnded", this.boundHandler)
    }
  }

  handleSlotRenderEnded(event) {
    if (this.dismissed) return
    if (event.slot.getSlotElementId() !== this.slotIdValue) return
    if (event.isEmpty) return

    this.containerTarget.classList.remove("hidden")
  }

  close() {
    this.dismissed = true
    this.containerTarget.classList.add("hidden")
  }
}
